import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowGridComponent } from './workflow-grid/workflow-grid.component';
import { WorkflowMainComponent } from './workflow-main/workflow-main.component';
import { SummaryTrialBalWfComponent } from './summary-trial-bal-wf/summary-trial-bal-wf.component';
import { ConsolidateViewWfComponent } from './consolidate-view-wf/consolidate-view-wf.component';
import { WorkflowRoutingModule } from './workflow-routing.module';

@NgModule({
  declarations: [WorkflowGridComponent, WorkflowMainComponent, SummaryTrialBalWfComponent, ConsolidateViewWfComponent],
  imports: [CommonModule, WorkflowRoutingModule],
  exports: [WorkflowGridComponent, WorkflowMainComponent, SummaryTrialBalWfComponent, ConsolidateViewWfComponent],
})
export class WorkflowModule {}
